import type { LayoutRuntime } from "../../../../shared/layouts/registry";

export const fixturesDefaultLayout: LayoutRuntime = {
  feature: "fixtures",
  layout: "default",
  rootClass: "gwd-livescore-layout--fixtures",
};
